import { useStoreUI } from '@assets/model/Store';
import { NavigateFunction, useNavigate } from 'react-router-dom';

export class NavUtils {
    constructor(private nav: NavigateFunction) {}

    openLink(url: string) {
        const ui = useStoreUI();
        if (ui.isKeyControlKeyDown) {
            window.open(url, '_blank');
        } else {
            this.nav(url);
        }
    }

    toReport(tickerId: string) {
        this.openLink(`/${tickerId}`);
    }

    back() {
        this.nav(-1);
    }

    home() {
        this.openLink('/');
    }

    knowledgeBase() {
        this.openLink('/knowledge');
    }
    
    navigateTo(path: string) {
        this.openLink(path);
    }
}

export function useNavUtils() {
    const nav = useNavigate();
    return new NavUtils(nav);
}
